<div class="col s12 m12 offset-m0 l12 offset-l0 xl12 offset-xl0">
  <h2>{{ isNew ? 'Add New Record' : 'Edit Record' }}</h2>
  <form novalidate [formGroup]="addEditForm" class="ie-display" id="add-edit-form">
    <!-- ERROR CONTAINER -->
    <div *ngIf="isErr && recordErrors.length > 0" id="record-error" class="bottom-margin-10">
      <h3 class="margin-0">Errors:</h3>
      <ul class="record-message" id="record-error-name">
        <li *ngFor="let error of recordErrors"><span class="k-icon k-i-error text-red"></span>
          {{error}}
        </li>
      </ul>
    </div>
    <!-- WARNING CONTAINER -->
    <div *ngIf="isIssue && recordIssues.length > 0" class="issue-container" id="record-issue">
      <h2 class="margin-0">Warnings:</h2>
      <ul class="record-message" id="record-issues-name">
        <li *ngFor="let issue of recordIssues"><span class="k-icon k-i-warning text-warning"></span>
          {{issue}}
        </li>
      </ul>
    </div>
    <!-- FORM INPUT FIELDS -->
    <div id="personal-details">
      <p class="form-label"><span class="bold headingtext">Personal Details</span></p>
      <div class="user-detail">
        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div [ngClass]="isNew ? 'col s5 m5 l5 xl5 padding-0' : 'col s5 m5 l4 xl4 padding-0'">
                  <label for="ssn" class="control-label bold">SSN<span *ngIf="isNew"
                      class="k-required">*</span>:</label>
                  <span *ngIf="!isNew" id="ssn-number" class="width-10em ssn-input">{{ssnNumber}}</span>
                  <kendo-maskedtextbox *ngIf="isNew" id="ssn" [mask]="ssnMask" formControlName="fullSSN"
                    class="width-10em ssn-input"></kendo-maskedtextbox>
                    <!-- && adjData?.fiscalYear > 2016 -->
                  <button title="Edit" *ngIf="isInvalid" [disabled]="isProcessing" id="editBtn" class="left-margin-5"
                    (click)="editClick(addEditForm, true)"><span type="button"
                      class="k-icon k-i-edit link-icon"></span></button>
                  <div class="top-margin-1">
                    <span class="tooltip-validation"
                      *ngIf="addEditForm.controls.fullSSN.touched && addEditForm.controls.fullSSN.errors">
                      {{config.ValidSSNMsg}}
                    </span>
                    <span class="tooltip-validation"
                      *ngIf="addEditForm.controls.fullSSN.errors?.noContectMsg">{{config.InfoNotFoundMsg}}</span>
                  </div>
                </div>
                <div [ngClass]="isNew ? 'col s5 m6 l6 xl6 padding-0' : 'col s5 m5 l4 xl3 padding-0'">
                  <label for="fiscalYear"
                    [ngClass]="isNew ? 'control-label right-margin-25 right-margin-0 bold' : 'control-label left-margin-2em right-margin-25 bold'">Fiscal
                    Year<span class="k-required" *ngIf="isNew">*</span>:</label>
                  <span *ngIf="!isNew" id="fiscal-year" class="width-10em">{{adjData?.fiscalYear}}</span>
                  <input *ngIf="isNew" type="text" id="fiscalYear" class="width-10em k-textbox kendo-textbox"
                    formControlName="fiscalYear" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div [ngClass]="isNew ? 'col s5 m5 l5 xl5 padding-0' : 'col s5 m5 l4 xl4 padding-0'">
                  <label for="firstName" class="control-label bold">First Name<span *ngIf="isNew"
                      class="k-required">*</span>:</label>
                  <span *ngIf="!isNew" class="left-margin-1em">{{adjData?.firstName}}</span>
                  <input *ngIf="isNew" type="text" id="firstName" maxlength="12" class="k-textbox kendo-textbox"
                    formControlName="firstName" />
                  <div class="top-margin-1">
                    <span class="tooltip-validation"
                      *ngIf="addEditForm.controls.firstName.touched && addEditForm.controls.firstName.errors">
                      {{config.ValidFnameMsg}}
                    </span>
                  </div>
                </div>
                <div [ngClass]="isNew ? 'col s2 m2 l2 xl2' : 'col s2 m2 l3 xl3'">
                  <div class="dsp-inlineBlock">
                    <label for="middleInitials"
                      [ngClass]="isNew ? 'control-label bold' : 'control-label bold right-margin-8 left-margin-5em'"
                      class="">MI:</label>
                    <span *ngIf="!isNew" class="left-margin-1em">{{adjData?.middleInitials}}</span>
                    <input *ngIf="isNew" type="text" id="middleInitials" (keyup)="trimContent($event)" maxlength="1"
                      class="k-textbox kendo-textbox" formControlName="middleInitials" />
                  </div>
                </div>
                <div [ngClass]="isNew ? 'col s5 m5 l5 xl5' : 'col s5 m5 l5 xl5 center-align left-align-txt'">
                  <label for="lastName" class="control-label bold">Last Name<span *ngIf="isNew"
                      class="k-required">*</span>:</label>
                  <span *ngIf="!isNew" class="left-margin-1em">{{adjData?.lastName}}</span>
                  <input *ngIf="isNew" type="text" id="lastName" maxlength="17" class="k-textbox"
                    formControlName="lastName" />
                  <div class="top-margin-1">
                    <span class="tooltip-validation"
                      *ngIf="addEditForm.controls.lastName.touched && addEditForm.controls.lastName.errors">
                      {{config.ValidLnameMsg}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="membership-style">
      <p class="form-label"><span class="bold headingtext">Membership</span></p>
      <div class="membership">
        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div class="col s7 m7 l7 xl7 padding-0 bottom-margin-10">
                  <div class="dsp-inlineBlock">
                    <label for="locationCode" class="control-label bold">Location<span class="k-required"
                        *ngIf="isNew">*</span>:</label>
                    <span class="left-margin-3em">{{locationCode.name}}</span>
                  </div>
                </div>
                <div class="col s5 m5 l5 xl5 bottom-margin-10">
                  <div class="dsp-inlineBlock">
                    <label for="systemCode" id="system-label" class="control-label bold">System<span class="k-required"
                        *ngIf="isNew">*</span>:</label>
                    <span class="left-margin-2em">{{systemCode?.description}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="reason-code">
      <p class="form-label"><span class="bold headingtext">Reason Code(s)</span></p>
      <div class="reasonCode">
        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div class="col s12 m12 l12 xl12 padding-0">
                  <div class="dsp-inlineBlock" id="reason-code">
                    <label for="resonCodes" class="control-label bold">Reason Codes<span
                        class="k-required">*</span>:</label>
                    <kendo-multiselect placeholder="Select reason code(s)" id="reason-code" class="left-margin-1em"
                      [data]="reasonCodesList" [textField]="'reasonCode'"
                      (valueChange)="onCodeChange($event, 'reasonCode')" [valueField]="'id'" [(ngModel)]="reasonCode"
                      formControlName="reasonCode" [ngModelOptions]="{standalone: true}" [isRequired]="true"
                      [valuePrimitive]="false">
                    </kendo-multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="schedule-info">
      <p class="form-label"><span class="bold headingtext">Schedule</span></p>
      <div class="schedule">
        <div class="row" *ngIf="adjData?.fiscalYear > 2016">
          <div class="col s12 m12 l12 xl12">
            <p class="bottom-margin-10" id="grid-msg" *ngIf="isNew || isInvalid" [innerHTML]="config.ScheduleMsg"></p>
            <kendo-grid #grid [kendoGridBinding]="fiscalYearGridData" [sortable]="true" id="fiscal-year-grid"
              [selectable]="selectableSettings" [rowSelected]="isRowSelected"
              (selectionChange)="onSelectionChange($event)">
              <!-- Mobile View  -->
              <kendo-grid-column media="(max-width: 900.98px)" title="Details" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <dl>
                    <dd>
                      <div class="align-left">
                        <span class="bold">Schedule Name: </span>
                        <span> {{ dataItem.payScheduleName }}</span>
                      </div>
                    </dd>
                    <dd>
                      <div class="align-left">
                        <span class="bold">Frequency: </span>
                        <span> {{ dataItem.frequency }}</span>
                      </div>
                    </dd>
                    <dd>
                      <div class="align-left">
                        <span class="bold">Pay Count: </span>
                        <span> {{ dataItem.payCount }}</span>
                      </div>
                    </dd>
                  </dl>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-checkbox-column media="(min-width: 901px)" [width]="30" *ngIf="isNew || isInvalid">
                <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
                  <div class="align-center">
                    <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox"
                      id="{{'scheduleChk'+idx}}" />
                    <label class="k-checkbox-label" for="{{'scheduleChk'+idx}}"></label>
                  </div>
                </ng-template>
              </kendo-grid-checkbox-column>
              <kendo-grid-column field="payScheduleName" media="(min-width: 901px)" title="Schedule Name" [width]="150">
              </kendo-grid-column>
              <kendo-grid-column field="frequency" media="(min-width: 901px)" title="Frequency" [width]="180">
              </kendo-grid-column>
              <kendo-grid-column field="payCount" media="(min-width: 901px)" title="Pay Count" [width]="50">
              </kendo-grid-column>
              <kendo-grid-command-column media="(min-width: 901px)" title="" [width]="30">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="align-center" id="form-btn" kendoTooltip>
                    <!-- isAdjEdit ? (isAdjEdit ? !dataItem.isScheduleSelected : isAdjEdit)  :  || !isNew || isEditAdj-->
                    <button id="viewBtn" (click)="loadScheduleDetails(dataItem);dataItem.isClicked=!dataItem.isClicked"
                      [disabled]="isNew || isEditAdj ? !dataItem.isScheduleSelected : isNew || isEditAdj">
                      <span type="button" *ngIf="!dataItem.isClicked" class="k-icon k-i-eye link-icon"
                        [ngClass]="dataItem.isScheduleSelected ? 'link-icon' : 'link-icon-disabled'"
                        title="View"></span>
                      <span *ngIf="dataItem.isClicked" class="k-icon k-i-loading inner"></span>
                    </button>
                  </div>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>
        </div>

        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div class="col s7 m7 l7 xl7 padding-0" *ngIf="isNew || isInvalid">
                  <div class="dsp-inlineBlock">
                    <label for="payPeriodStartDate" class="control-label bold">Start Date<span
                        class="k-required">*</span>:</label>
                    <!--Needs to add later [max]="maxDate"-->
                    <kendo-datepicker id="payPeriodStartingDate" [min]="minDate"
                    format="MM/dd/yyyy" class="textbox data-selector left-margin-10"
                      formControlName="payPeriodStartDate" id="beginningDate" (valueChange)="onStartDateChange($event)"
                      placeholder="mm/dd/yyyy">
                    </kendo-datepicker>
                    <div class="top-margin-1" *ngIf="!isStartDateValid">
                      <span class="tooltip-validation left-margin-20p inherit-position">
                        {{config.StartDateError}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col s5 m5 l5 xl5 padding-0">
                  <div class="dsp-inlineBlock">
                    <label for="payPeriodEndDate"
                      [ngClass]="(isNew || isInvalid) ? 'control-label bold' : 'control-label bold'">End
                      Date<span class="k-required" *ngIf="isNew || isInvalid">*</span>:</label>
                    <!--Needs to add later [max]="maxDate" -->
                    <span *ngIf="!isNew && !isInvalid" class="left-margin-1em"
                      id="payPeriodEndingDate">{{adjData?.payPeriodEndDate | date: 'MM/dd/yyyy'}}</span>
                    <kendo-datepicker *ngIf="isNew || isInvalid" id="payPeriodEndingDate" [min]="minDate"
                      [format]="'MM/dd/yyyy'" class="textbox data-selector left-margin-10"
                      formControlName="payPeriodEndDate" id="endingDate" (valueChange)="onEndDateChange($event)"
                      placeholder="mm/dd/yyyy">
                    </kendo-datepicker>
                    <div class="top-margin-1" *ngIf="!isEndDateValid">
                      <span class="tooltip-validation left-margin-20p inherit-position">
                        {{config.EndDateError}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div kendoTooltip class="top-margin-15" position="right" tooltipWidth="250">
      <div id="pay-style">
        <p class="form-label"><span class="bold headingtext">Pay</span></p>
        <div class="pay">
          <div class="row">
            <div class="col s12 m12 l12 xl12">
              <table id="payTable" aria-hidden="true">
                <tbody id="payBody">
                  <tr>
                    <th scope="row" class="kendo-th">
                      <label for="actualAnnualCompensation" class="head-label">Actual Annual
                        Compensation</label><em class="head-label left-margin-5">(Dollars
                        only, no cents)</em><span class="k-required">*</span><span [title]="config.AACInfo"
                        class="k-icon k-i-information k-i-info"></span>
                    </th>
                    <td>
                      <div class="input-validation">
                        <kendo-numerictextbox id="actualAnnualCompensation" [format]="'c0'"
                          formControlName="actualAnnualCompensation" maxlength="6" placeholder="$0"
                          (input)="setIntMaxVal('actualAnnualCompensation')">
                        </kendo-numerictextbox>
                        <div class="top-margin-1">
                          <span class="left-margin-0 tooltip-validation"
                            *ngIf="addEditForm.controls.actualAnnualCompensation.touched && addEditForm.controls.actualAnnualCompensation.errors">
                            <span *ngIf="addEditForm.controls.actualAnnualCompensation.errors.max; else noMaxErr">Max
                              AAC limit is {{config.maxAEC}}</span>
                            <ng-template #noMaxErr>{{config.InvalidAAC}}</ng-template>
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="kendo-th">
                      <label for="actualAnnualCompensation" class="head-label">Annual Earnable
                        Compensation</label><em class="head-label left-margin-5">(Dollars
                        only, no cents)</em><span class="k-required">*</span><span [title]="config.AECInfo"
                        class="k-icon k-i-information k-i-info"></span>
                    </th>
                    <td>
                      <div class="input-validation">
                        <kendo-numerictextbox id="actualEarnableCompensation" [format]="'c0'"
                          formControlName="actualEarnableCompensation" maxlength="6" placeholder="$0"
                          (input)="setIntMaxVal('actualEarnableCompensation')">
                        </kendo-numerictextbox>
                        <div class="top-margin-1">
                          <span class="left-margin-0 tooltip-validation"
                            *ngIf="addEditForm.controls.actualEarnableCompensation.touched && addEditForm.controls.actualEarnableCompensation.errors">
                            <span
                              *ngIf="addEditForm.controls.actualEarnableCompensation.errors.max; else noMaxAECErr">Max
                              AEC limit is {{config.maxAEC}}</span>
                            <ng-template #noMaxAECErr> {{config.InvalidAEC}}</ng-template>
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="kendo-th">
                      <label for="employeeContribution" class="head-label">Employee
                        Contribution</label><em class="head-label left-margin-5">(Dollars
                        and cents, with decimal)</em><span class="k-required">*</span><span
                        [title]="config.ContributionInfo" class="k-icon k-i-information k-i-info"></span>
                    </th>
                    <td>
                      <div class="input-validation">
                        <kendo-numerictextbox id="employeeContribution" [format]="'c2'" [decimals]="'2'"
                          placeholder="$0.00" formControlName="employeeContribution"
                          (input)="setDecMaxVal('employeeContribution');">
                        </kendo-numerictextbox>
                        <div class="top-margin-1">
                          <span class="left-margin-0 tooltip-validation"
                            *ngIf="addEditForm.controls.employeeContribution.touched && addEditForm.controls.employeeContribution.errors">
                            {{config.InvalidContribution}}
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="kendo-th">
                      <label for="payPeriodBaseSalary" class="head-label">Pay Period Base
                        Salary</label><em class="head-label left-margin-5">(Dollars
                        and cents, with decimal)</em><span class="k-required">*</span><span [title]="config.PPBSInfo"
                        class="k-icon k-i-information k-i-info"></span>
                    </th>
                    <td>
                      <div class="input-validation">
                        <kendo-numerictextbox id="payPeriodBaseSalary" [format]="'c2'" [decimals]="'2'"
                          placeholder="$0.00" formControlName="payPeriodBaseSalary"
                          (input)="setDecMaxVal('payPeriodBaseSalary')"></kendo-numerictextbox>
                        <div class="top-margin-1">
                          <span class="left-margin-0 tooltip-validation"
                            *ngIf="addEditForm.controls.payPeriodBaseSalary.touched && addEditForm.controls.payPeriodBaseSalary.errors">
                            {{config.InvalidPPBaseSalary}}
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="kendo-th">
                      <label for="hoursWorked" class="head-label">Hours Worked</label><em
                        class="head-label left-margin-5">(To one decimal
                        point, ex. 80.0)</em><span class="k-required">*</span><span [title]="config.HoursWorkInfo"
                        class="k-icon k-i-information k-i-info"></span>
                    </th>
                    <td>
                      <div class="input-validation">
                        <kendo-numerictextbox id="hoursWorked" [format]="'n1'" [decimals]="'1'" placeholder="0.0"
                          formControlName="hoursWorked">
                        </kendo-numerictextbox>
                        <div class="top-margin-1">
                          <span class="left-margin-0 tooltip-validation"
                            *ngIf="addEditForm.controls.hoursWorked.touched && addEditForm.controls.hoursWorked.errors">
                            {{config.InvalidHoursWork}}
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="kendo-th">
                      <label for="standardHours" class="head-label">Standard Hours</label><em
                        class="head-label left-margin-5">(To one
                        decimal point, ex. 80.0)</em><span class="k-required">*</span><span
                        [title]="config.StandardHoursInfo" class="k-icon k-i-information k-i-info"></span>
                    </th>
                    <td>
                      <div class="input-validation">
                        <kendo-numerictextbox id="standardHours" [format]="'n1'" [decimals]="'1'" placeholder="0.0"
                          formControlName="standardHours">
                        </kendo-numerictextbox>
                        <div class="top-margin-1">
                          <span class="left-margin-0 tooltip-validation"
                            *ngIf="addEditForm.controls.standardHours.touched && addEditForm.controls.standardHours.errors">
                            {{config.InvalidStandardHours}}
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="kendo-th">
                      <label for="percentFullTime" class="head-label">Percent FullTime</label>
                      <em class="head-label left-margin-5">(No decimal or percent sign)</em><span
                        class="k-required">*</span><span [title]="config.FTRangeInfo"
                        class="k-icon k-i-information k-i-info"></span>
                      <span class="float-right">%</span>
                    </th>
                    <td>
                      <div class="input-validation">
                        <kendo-numerictextbox id="percentFullTime" [format]="'n0'" [decimals]="0" placeholder="0"
                          formControlName="percentFullTime">
                        </kendo-numerictextbox>
                        <div class="top-margin-1">
                          <span class="left-margin-0 tooltip-validation"
                            *ngIf="addEditForm.controls.percentFullTime.touched && addEditForm.controls.percentFullTime.errors">
                            <span
                              *ngIf="addEditForm.controls.percentFullTime.errors.max || addEditForm.controls.percentFullTime.errors.min; else notValidFT">{{config.InvalidFTRange}}</span>
                            <ng-template #notValidFT>{{config.InvalidFT}}</ng-template>
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top-padding-15 align-right">
      <button class="k-button k-primary background-red margin-5" id="add-edit-save-btn"
        [disabled]="!addEditForm.valid || !addEditForm.dirty || !scheduleSelected || !isStartDateValid || !isEndDateValid || isProcessing"
        (click)="onSave(addEditForm)">
        <span *ngIf="!isProcessing">Save</span>
        <span *ngIf="isProcessing" class="k-icon k-i-loading inner"></span>
      </button>
      <button class="k-button background-red text-white margin-5" type="button" id="cancel-button"
        (click)="onCancel(addEditForm)">Cancel</button>
    </div>
  </form>
</div>

<!-- SCHEDULE DETAILS -->
<kendo-dialog title="Schedule Details" *ngIf="scheduleDetailDialog" (close)="scheduleDetailDialog=false" [width]="600"
  [height]="750" id="schedule-details-dialog" class="app-dialog">
  <div class="right-margin-5">
    <table class="printTable2" aria-hidden="true">
      <thead>
        <tr>
          <th scope="col" class="align-id color-white">#</th>
          <th scope="col" class="align-date color-white">PPED </th>
          <th scope="col" class="align-date color-white">Pay Date</th>
        </tr>
      </thead>
      <tbody class="totals-table benefits-table">
        <tr id="Entries" *ngFor="let item of scheduleEntry; let row_no = index">
          <td class="align-id border-style">
            {{row_no + 1}}
          </td>
          <td class="align-date border-style">{{item.payPeriodEndDate | date: 'MM/dd/yyyy'}}</td>
          <td class="align-date border-style">{{item.payDate | date: 'MM/dd/yyyy'}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</kendo-dialog>

<!-- NEXT DEVELOPMENT COMMENT PLEASE CONFIRM DIALOG -->
<kendo-dialog title="Please Confirm" class="app-dialog" *ngIf="isConfirmOpened" (close)="isConfirmOpened = false"
  [minWidth]="450" id="confirm-dialog">
  <p class="dialog-heading margin-30 align-center">All unsaved changes will be lost. <br> Are you sure you want to
    continue?</p>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" id="confirm-dialog-no" (click)="isConfirmOpened = false"
      primary="true">No</button>
    <button kendoButton class="k-button" id="confirm-dialog-yes" (click)="close()" primary="true">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
